<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    @if (managerRoles.includes(role())) {
      {{ 'tickets.answer' | translate }}
    } @else {
      {{ 'tickets.answerCommercial' | translate }}
    }
  </div>
  <form [formGroup]="formGroup">
    <ion-item class="description"
      lines="none">
      <ion-textarea autocapitalize="on"
        class="description"
        formControlName="description"
        rows="5"
        [placeholder]="'calendar.site.description' | translate">
      </ion-textarea>
    </ion-item>
    <div class="ion-margin-top">
      <ion-button color="light"
        (click)="save()">
        {{ 'general.save' | translate }}
      </ion-button>
    </div>
  </form>
</app-main-dialog>